module.exports = __webpack_public_path__ + "img/level_16_premium.ce93a907.svg";